import {defineNuxtPlugin} from "#app";
import VueDragscroll from "vue-dragscroll";

export default defineNuxtPlugin(nuxtAppMain => {
  const nuxtApp = useNuxtApp();
  nuxtApp.vueApp.use(VueDragscroll);
})
